import { render, staticRenderFns } from "./Discord.vue?vue&type=template&id=c934b870&"
import script from "./Discord.vue?vue&type=script&lang=ts&"
export * from "./Discord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports